import { CountryModel } from "../../commons/models/country-model";

export const CountriesConstants: CountryModel[] = [
    { 
        id: "1", name: 'USA', icon: 'usa-flag.png'
    },
    {
        id: "2", name: 'Colombia', icon: 'colombia-flag.png'
    },
    {
        id: "3", name: 'Honduras', icon: 'honduras-flag.png'
    },
    {
        id: "4", name: 'Panama', icon: 'panama-flag.png'
    }
]